import type { ReactElement } from 'react';

/** 네이버 로그인 버튼의 "N" 심볼 — 글자 색(currentColor)을 따르고 크기는 버튼이 정한다. 꾸밈이라 보조기기에서 감춘다. */
export const NaverIcon = (): ReactElement => (
  <svg viewBox="0 0 24 24" aria-hidden fill="currentColor">
    <path d="M16.27 12.85 7.38 0H0v24h7.73V11.16L16.62 24H24V0h-7.73z" />
  </svg>
);
